import { useMemo } from 'react';
import type { ColumnMapping, FileMapping, FileUploadMetadata } from 'venn-api';
import type { DataUploaderMode } from 'venn-components';
import { getTypeId } from '../../fetchers';
import { getGlobalValues } from '../mapping/helpers';

interface UseIsPriceParams {
  metadata: FileUploadMetadata;
  mapping: FileMapping;
  editingSeriesId?: string;
  mode: DataUploaderMode;
}

export const useIsPrice = ({ metadata, mapping, editingSeriesId, mode }: UseIsPriceParams): boolean => {
  const mappingColumn = useMemo(
    () => mapping.columns.find((c) => c.seriesId === editingSeriesId),
    [mapping.columns, editingSeriesId],
  );

  const priceId = useMemo(() => getTypeId(metadata, 'metricType', 'Price'), [metadata]);

  const globalMetricId = useMemo(() => {
    const cols: ColumnMapping[] = mappingColumn ? [mappingColumn] : [];
    return getGlobalValues(cols, mode).globalMetricId;
  }, [mappingColumn, mode]);

  return useMemo(() => globalMetricId === priceId, [globalMetricId, priceId]);
};
